<template>
  <div>
    <a-modal
      :visible="visible"
      wrapClassName="responsive-modal"
      title="买赠设置"
      :confirmLoading="confirmLoading"
      @ok="confirm"
      @cancel="hide()"
      closable
    >
      <div style="width: 100%">
        <Layout style="width: 100%" :showMenu="false" :menuList="menuList" :defaultKeys="[0]" :activeKey.sync="key" :mainImage="true" :mainImageUrl="record.images.length ? record.images[0] : ''" >
          <template slot="content" >
            <div v-show="key === 0" style="height:100%">
              <div class="font-14 font-bold m-b-20" style="color: #363B45" >{{ menuList[key].name }}</div>
              <div >
                <!-- <tk-flex class="m-b-24">
                  <div class="font-14 unshrink" style="color: #363B45" >买赠主图：</div>
                  <div class="fill">
                    <ak-type-input v-model="mainImage" class="hide-label" :field="mainImageField" style="margin-bottom: 0;width: 100%" />
                    <tk-flex middle class="m-t-15" >
                      <a-icon type="exclamation-circle" theme="filled" style="color: #AFB4BC; fontSize: 15px;" />
                      <div class="font-12 m-l-4" style="color: #808690">
                        上传1张，建议上传尺寸为750x562PX
                      </div>
                    </tk-flex>
                  </div>
                </tk-flex> -->
                <tk-flex style="width: 100%">
                  <div class="font-14 unshrink" style="color: #363B45" >包含赠品：</div>
                </tk-flex>
                <div class="m-t-10 m-b-24">
                  <!-- <a-button class="editable-add-btn m-b-10" @click="handleAdd">
                    添加
                  </a-button> -->
                  <a-table
                    v-if="device !== 'mobile'"
                    style="width: 100%" :columns="columns" :data-source="data" bordered :pagination="false" :scroll="{x: 600}" size="small">
                    <div slot="image" slot-scope="text">
                      <viewer v-if="text" :images="[text]">
                        <img :src="text" style="width: 40px;height:40px;object-fit:cover;border-radius: 6px;border: 1px solid #DBDDE1;" />
                      </viewer>
                      <span v-else> 暂无 </span>
                    </div>
                    <div slot="gift" slot-scope="">
                      <SelectGift placeholder="请选择" :where="where" allowClear showSearch :value.sync="gift" :valueData.sync="giftData" style="width: 100%" ></SelectGift>
                      <!-- <ak-type-input v-model="gift" class="hide-label" :field="giftField" style="margin-bottom: 0;width: 100%" /> -->
                    </div>
                  </a-table>
                  <div v-else>
                    <a-descriptions size="small" bordered v-for="(item,index) in data" :key="index" style="margin-bottom: 20px">
                      <a-descriptions-item
                        v-for="( itm, i) in columns" :key="`item${i}`"
                        :label="itm.title"
                      >
                        <div v-if="itm.dataIndex === 'image'">
                          <viewer v-if="item[itm.dataIndex]" :images="[item[itm.dataIndex]]">
                            <img :src="item[itm.dataIndex]" style="width: 40px;height:40px;object-fit:cover;border-radius: 6px;border: 1px solid #DBDDE1;" />
                          </viewer>
                          <span v-else> 暂无 </span>
                        </div>
                        <div v-else-if="itm.dataIndex === 'gift'">
                          <SelectGift placeholder="请选择" :where="where" allowClear showSearch :value.sync="gift" :valueData.sync="giftData" style="width: 100%" ></SelectGift>
                        </div>
                        <div v-else>{{ item[itm.dataIndex] }}</div>
                      </a-descriptions-item>
                    </a-descriptions>
                  </div>
                </div>

                <tk-flex class="m-b-24">
                  <div class="font-14 unshrink" style="color: #363B45" >截止日期：</div>
                  <div class="fill">
                    <a-date-picker v-model="deadline"  @change="onChange" :disabledDate="disabledDate" />
                    <!-- <ak-type-input v-model="deadline" class="hide-label" :field="deadlineField" style="margin-bottom: 0;width: 100%" /> -->
                  </div>
                </tk-flex>

                <tk-flex>
                  <div class="font-14 unshrink" style="color: #363B45" >是否邮寄：</div>
                  <a-radio-group v-model="pinkage">
                    <a-radio :value="true">
                      是
                    </a-radio>
                    <a-radio :value="false">
                      否
                    </a-radio>
                  </a-radio-group>
                </tk-flex>
              </div>

            </div>
          </template>
        </Layout>
      </div>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import Layout from '../../components/layout.vue'
import SelectGift from './selectGift.vue'
export default {
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    winWinMerchantProduct: Object,
    record: Object, // 当前行的数据
    vm: Object, // 触发这个action的组件对象，通常为modelTable或modelTree
    fields: Array, // 当前model的fields对象
    model: Object, // 当前model对象
    className: String, // 当前model的className
    modelName: String, // 当前model的名称
    category: String // 假如当前model显示为category格式，则会将当前的值传入
  },
  data () {
    return {
      confirmLoading: false,
      menuList: [
        {
          name: '买赠设置'
        }
      ],
      key: 0,
      giftType: '1',
      mainImage: '',
      mainImageField: {
        type: 'Image'
      },
      columns: [
        {
          title: '图片',
          dataIndex: 'image',
          key: 'image',
          scopedSlots: { customRender: 'image' },
          width: 100
        },
        {
          title: '名称',
          dataIndex: 'gift',
          key: 'gift',
          scopedSlots: { customRender: 'gift' },
          width: 300
        },
        {
          title: '数量',
          dataIndex: 'number',
          key: 'number',
          width: 80
        },
        {
          title: '成本价',
          key: 'costPrice',
          dataIndex: 'costPrice',
          scopedSlots: { customRender: 'costPrice' },
          width: 100
        },
        {
          title: '售价',
          key: 'price',
          dataIndex: 'price',
          scopedSlots: { customRender: 'price' },
          width: 100
        }
        // {
        //   title: '操作',
        //   key: 'action',
        //   scopedSlots: { customRender: 'action' },
        //   fixed: 'right',
        //   width: 80
        // }
      ],
      data: [
        {
          image: '',
          gift: '',
          number: '1件',
          costPrice: '',
          price: ''
        }
      ],
      gift: '',
      giftData: {},
      giftField: {
        name: 'gift',
        note: '介绍人',
        type: 'Pointer',
        targetClass: 'gift', // 当数据类型为Pointer时必填，指定查询对象
        searchKey: ['name'], // 仅在 Pointer类型下有效，根据输入内容搜索的字段名
        listWhere: (where) => {
          where.isDelete = {
            $ne: true
          }
        }
      },
      pinkage: false,
      deadline: '',
      deadlineField: {
        name: 'deadline',
        type: 'Date',
        disabledDate: (current) => {
          console.log('日期', current)
          // Can not select days before today and today
          return current && current < moment().endOf('day')
        }
      },

      columnsRegion: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          scopedSlots: { customRender: 'index' },
          width: 70
        },
        {
          title: '代理商',
          dataIndex: 'agent',
          key: 'agent',
          scopedSlots: { customRender: 'agent' },
          width: 150
        },
        {
          title: '买赠主图',
          dataIndex: 'mainImage',
          key: 'mainImage',
          scopedSlots: { customRender: 'mainImage' },
          width: 100
        },
        {
          title: '赠品图片',
          dataIndex: 'image',
          key: 'image',
          scopedSlots: { customRender: 'image' },
          width: 100
        },
        {
          title: '赠品名称',
          dataIndex: 'gift',
          key: 'gift',
          scopedSlots: { customRender: 'gift' },
          width: 150
        },
        {
          title: '数量',
          dataIndex: 'number',
          key: 'number',
          width: 80
        },
        {
          title: '赠品售价',
          key: 'price',
          dataIndex: 'price',
          scopedSlots: { customRender: 'price' },
          width: 100
        },
        {
          title: '赠品邮寄',
          key: 'pinkage',
          dataIndex: 'pinkage',
          scopedSlots: { customRender: 'pinkage' },
          width: 120
        },
        {
          title: '截止日期',
          key: 'deadline',
          dataIndex: 'deadline',
          scopedSlots: { customRender: 'deadline' },
          width: 250
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right',
          width: 80
        }
      ],
      dataRegion: [
      ],
      cacheData: [],
      regionObj: {
        objectId: '',
        agent: '',
        agentData: {},
        mainImage: '',
        image: '',
        gift: '',
        giftData: {},
        number: '1件',
        price: '',
        pinkage: false,
        deadline: ''
      },
      editingKey: '',
      agentField: {
        name: 'agent',
        note: '代理商',
        type: 'Pointer',
        targetClass: '_User', // 当数据类型为Pointer时必填，指定查询对象
        searchKey: ['name'], // 仅在 Pointer类型下有效，根据输入内容搜索的字段名
        listWhere: (where) => {
          where.level = '3'
          where.isDelete = {
            $ne: true
          }
        }
      },
      pinkageField: {
        name: 'pinkage',
        type: 'Boolean'
      }

    }
  },
  // 组件
  components: {
    Layout,
    SelectGift
  },
  computed: {
    where () {
      return {
        isDelete: {
          $ne: true
        }
        // isArea: true,
        // user: this.$store.state.user.objectId
      }
    },
    _visible: {
      get () {
        return this.value
      },
      set (v) {
        console.log(v)
        // v-model接收input事件的值来更新value
        this.$emit('update:visible', v)
      }
    }
  },
  watch: {
    gift (val) {
      this.data[0].gift = val
      if (this.giftData && this.giftData.objectId) {
        this.data[0].image = this.giftData.image
        this.data[0].costPrice = this.giftData.costPrice
        this.data[0].price = this.giftData.price
      } else {
        this.data[0].image = ''
        this.data[0].costPrice = ''
        this.data[0].price = ''
      }
    }
  },
  mounted () {
    this.init()
    this.$tkParse.post('/commodity/WWMProductActivity', {
      commodity: this.record.objectId
    })
  },
  methods: {
    // 初始化
    async init () {
      await this.getRole()
    },
    disabledDate (current) {
      return current && current < moment().subtract(1, 'days')// 当前日期之前不能选择（不含当前日）
    },
    onChange (date, dateString) {
      this.deadline = dateString
    },
    async confirm () {
      console.log(this.$store.state.user)
      this.confirmLoading = true
      try {
        // 判断mainImage gift deadline pinkage 是否为空
        // if (!this.mainImage) {
        //   this.$notification['warning']({
        //     message: '警告',
        //     description: '主图不能为空'
        //   })
        //   this.confirmLoading = false
        //   return
        // }
        if (!this.gift) {
          this.$notification['warning']({
            message: '警告',
            description: '赠品不能为空'
          })
          this.confirmLoading = false
        }
        if (!this.deadline) {
          this.$notification['warning']({
            message: '警告',
            description: '截止日期不能为空'
          })
          this.confirmLoading = false
        }
        let post = await this.$tkParse.post(`/classes/giftApply`, {
          gift: this.gift,
          mainImage: null,
          pinkage: this.pinkage,
          deadline: new Date(moment(this.deadline).endOf('day').format('YYYY-MM-DD HH:mm:ss')).toISOString(),
          winWinMerchantProduct: this.winWinMerchantProduct.objectId,
          commodity: this.record.objectId,
          status: '0',
          warZone: this.warZone,
          regional: this.regional,
          agent: this.$store.state.user.objectId
        })

        await this.$tkParse.post(`/classes/platformNotice`, {
          head: '发现代理商申请买赠活动!',
          type: 'gift',
          agent: null,
          className: 'regionalGift',
          readUsers: [],
          resourceId: post.data.objectId,
          associationType: 'regionalGift',
          permissionF: 'gift',
          permissionS: 'regionalGift'
        })

        this.$notification['success']({
          message: '成功',
          description: '操作成功'
        })

        // this.vm.$refs.management.$refs.table.refresh()
        this.vm.refreshGift() // 数据更新后，你可能需要刷新modelTable
        this.$emit('complete') // 触发complete事件，会自动关闭该组件
        this.vm.showGift = false
      } catch (e) {
        console.log('错误', e)
        this.confirmLoading = false
        this.$notification['error']({
          message: '错误',
          description: '添加失败'
        })
      }
    },
    hide () {
      this.vm.refreshGift() // 数据更新后，你可能需要刷新modelTable
      this.vm.showGift = false
    },
    // 获取角色
    async getRole () {
      let user = await this.$tkParse.get(`/classes/_User/${this.$store.state.user.objectId}`, {
        params: {
          include: 'department'
        }
      })
      console.log(user)
      this.warZone = user.data.department.parentNode
      this.regional = user.data.department.objectId
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep{
    .ant-select{
      width: 100% !important;
    }
    .upLoad{
      .image-input-wrap{
        width: 100%;
      }
      .empty{
        span{
          display: none;
        }
      }
    }
  }
</style>
